import { DonutChart } from "@mantine/charts"
import { Center } from "@mantine/core"
import countBy from "lodash/countBy"
import mean from "lodash/mean"
import { useTranslation } from "react-i18next"
import { scaleToValue, valueToScale } from "../../questions/utils"
import { valueToThemeColor } from "../../utils"
import type { IMultiAnswerProps } from "./types"
import { filterAnswersWithValue } from "./utils"

export function MultiAnswerScale({ question, answers }: IMultiAnswerProps) {
  const { t } = useTranslation()
  const validAnswers = filterAnswersWithValue(answers).filter((a) => a.value > 0)
  const values = countBy(validAnswers, (a) => valueToScale(a.value, question))
  const meanValue = mean(validAnswers.map((a) => a.value))

  const data = Object.entries(values)
    .map(([value, amount]) => ({
      name: value === "null" ? t("No answer") : value,
      value: amount as number,
      color: value === "null" ? "gray" : valueToThemeColor(scaleToValue(Number(value), question)),
    }))
    .sort((a, b) => Number(b.name) - Number(a.name))

  return (
    <Center h="100%">
      <DonutChart
        size={200}
        data={data}
        styles={{
          label: {
            fontSize: 36,
            fontWeight: 500,
            fill: `var(--mantine-color-${valueToThemeColor(meanValue).replace(".", "-")}-6)`,
          },
        }}
        chartLabel={valueToScale(meanValue, question).toFixed(1)}
        tooltipDataSource="segment"
      />
    </Center>
  )
}
